/**
 * FeatureGate — wraps a Student Hub module and shows a "Coming Soon" placeholder
 * when the feature is disabled via feature flags.
 *
 * Scoped ONLY to Student Hub modules.
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft, Construction } from 'lucide-react';
import { isFeatureEnabled } from '../../config/studentHubFeatureFlags';

export default function FeatureGate({ featureSlug, children }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (isFeatureEnabled(featureSlug)) {
    return children;
  }

  return (
    <div className="feature-gate-container" data-testid={`feature-gate-${featureSlug}`}>
      <div className="feature-gate-card">
        <Construction size={48} className="feature-gate-icon" />
        <h2 className="feature-gate-title">{t('shf.comingSoon')}</h2>
        <p className="feature-gate-desc">{t('shf.featureComingSoonDesc')}</p>
        <button
          className="feature-gate-back"
          onClick={() => navigate('/student-hub')}
          data-testid="feature-gate-back"
        >
          <ArrowLeft size={16} />
          {t('shf.backToStudentHub')}
        </button>
      </div>
    </div>
  );
}
